// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__1WocY","slickslide":"carousel_slickslide__2x-sO","slideImg":"carousel_slideImg__trEUd"};